/**
    * Convierte el mensaje de respuesta con estructura XML recibido en la solicitud para obtener la configuración de gráficos a formato JSON con estrucutura conveniente para su lectura.
    * @param {Object[]} xmlData - Mensaje recibido para solicitud de configuración inicial de gráfico.
    * @returns {Array.<JSON> }Opciones para configuración de gráfico.
*/
function xmlParserChartConfig(xmlData) {
    var chartConfig = []
    const chartCategories = xmlData.getElementsByTagName('chartcategory');
    chartCategories.map((chartCategory) => {
        var name = chartCategory.children[1].value;
        var id = chartCategory.children[0].value;
        var parameters = [];
        var parametersXML = chartCategory.getElementsByTagName('parameter');
        parametersXML.map((parameter) => {
            var parameterId = parameter.children[0].value;
            var parameterName = parameter.children[1].value;
            var parameterOptions = [];
            var optionsXML = parameter.children[2].children;
            optionsXML.map((option) => {
                var optionId = option.getElementsByTagName('id')[0].value;
                var optionName = option.getElementsByTagName('name')[0].value;
                parameterOptions.push({
                    id: optionId,
                    name: optionName,
                })
            })
            parameters.push({
                id: parameterId,
                name: parameterName,
                options: parameterOptions
            })
        })
        var item = {
            name: name,
            id: id,
            parameters: parameters
        }
        chartConfig.push(item);
    })
    return chartConfig;
}

export default xmlParserChartConfig;